import { useBurnBatchMutation, useBurnNFTMutation } from "@/api/inventory/burn";
import { useConfirmationDialog } from "@/context/ConfirmationDialog";
import { Button, type ButtonProps } from "@mantine/core";

export function BurnButton({
	type,
	name,
	collection,
	tokenId,
	...buttonProps
}: {
	type: "ERC721A" | "ERC1155";
	name: string;
	collection: string;
	tokenId: number;
} & ButtonProps) {
	const { confirm, prompt } = useConfirmationDialog();
	const burnNFTMutation = useBurnNFTMutation();
	const burnBatchMutation = useBurnBatchMutation();

	const handleBurnERC721A = async () => {
		await burnNFTMutation.mutateAsync({
			collectionAddress: collection,
			tokenId: Number(tokenId),
		});
	};

	const handleBurnERC1155 = async () => {
		const amount = await prompt(
			"Enter Amount",
			"Please enter the amount to burn:",
			"1",
			"Burn",
			"Cancel",
		);

		if (!amount) {
			return;
		}

		const confirmed = await confirm(
			"Confirm Burn",
			`Are you sure you want to burn ${name}?
			Quantity: ${amount}`,
			"Burn",
			"Cancel",
		);

		if (!confirmed) {
			return;
		}

		await burnBatchMutation.mutateAsync({
			collectionAddress: collection,
			tokenAmounts: [
				{
					tokenId: Number(tokenId),
					amount: Number(amount),
				},
			],
		});
	};

	if (type === "ERC721A") {
		return (
			<Button
				{...buttonProps}
				loading={burnNFTMutation.isPending}
				disabled={burnNFTMutation.isPending || burnNFTMutation.isSuccess}
				onClick={handleBurnERC721A}
			>
				Burn
			</Button>
		);
	}
	if (type === "ERC1155") {
		return (
			<Button
				{...buttonProps}
				loading={burnBatchMutation.isPending}
				disabled={burnBatchMutation.isPending || burnBatchMutation.isSuccess}
				onClick={handleBurnERC1155}
			>
				Burn
			</Button>
		);
	}
}
